import React, { useState } from "react";
import { Form, Input, Typography, Button, Divider, message } from "antd";
import axios from "axios";
import streenLogo from "../../img/logo.png";
import { QRCodeCanvas } from "qrcode.react";
import { UsergroupAddOutlined } from "@ant-design/icons";
const { Title } = Typography;

const BulkRegister = () => {
  const [bulkText, setBulkText] = useState("");
  const [bulkPreview, setBulkPreview] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSubmitBulk = async () => {
    if (!bulkText) return;

    setLoading(true);
    try {
      // parse input lines
      const students = bulkText.split("\n").map((line) => {
        const [username, email, password] = line
          .split(",")
          .map((s) => s.trim());
        return { username, email, password: password || "" };
      });

      const res = await axios.post("/api/auth/register/bulk", { students });

      // Backend must return res.data.students array
      if (Array.isArray(res.data.students)) {
        setBulkPreview(res.data.students);
        setBulkText("");
        message.success("Schüler erfolgreich erstellt!");
      } else {
        message.error("Backend returned unexpected response");
      }
    } catch (err) {
      message.error(err.response?.data || "Fehler beim Erstellen der Schüler");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 0" }}>
        <Title level={2}>
          <span>
            <UsergroupAddOutlined /> Bulk Registrieren
          </span>
        </Title>

        <Divider />

        <p>Geben Sie die Schüler ein (CSV oder Tabelle):</p>
        <Input.TextArea
          placeholder="username,email,password(optional)"
          rows={8}
          value={bulkText}
          onChange={(e) => setBulkText(e.target.value)}
        />

        <Form.Item style={{ textAlign: "center", padding: "20px 0" }}>
          <Button
            type="primary"
            onClick={handleSubmitBulk}
            disabled={!bulkText}
            htmlType="submit"
            loading={loading}
            size="large"
          >
            Benutzer Registrieren
          </Button>
        </Form.Item>

        {bulkPreview && bulkPreview.length > 0 && (
          <div className="print-area" style={{ marginTop: 24 }}>
            <h3>Erstellte Schüler</h3>
            {bulkPreview.map((user, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 12,
                  padding: 16,
                  marginBottom: 12,
                  background: "#fff",
                  textAlign: "center",
                }}
              >
                <img src={streenLogo} alt="STREEN" style={{ width: 100 }} />
                <p>
                  <strong>Benutzername:</strong> {user.username}
                </p>
                <p>
                  <strong>Passwort:</strong>{" "}
                  {user.generated_password || user.password}
                </p>
                <QRCodeCanvas value={user.qr_code} size={120} />
              </div>
            ))}

            <Form.Item style={{ textAlign: "center", paddingBottom: 30 }}>
              <Button
                type="primary"
                style={{ marginTop: 12 }}
                onClick={() => window.print()}
                size="large"
              >
                Drucken
              </Button>
            </Form.Item>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkRegister;
